import { render, staticRenderFns } from "./DataTableCell.vue?vue&type=template&id=666846a6&scoped=true&"
import script from "./DataTableCell.vue?vue&type=script&lang=js&"
export * from "./DataTableCell.vue?vue&type=script&lang=js&"
import style0 from "./DataTableCell.vue?vue&type=style&index=0&id=666846a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666846a6",
  null
  
)

export default component.exports